<div>

  <dx-lookup data-testid="user-lookup-lookup" #lookup
  [dataSource]="users"
  placeholder="Search for a user"
  displayExpr="fullName"
  valueExpr=""
  (onValueChanged)="onUserSelected($event)"
  [searchEnabled] = "searchEnabled" >
  </dx-lookup>

</div>
